export default "<div class=\"layout-content\">\r\n    <router-outlet></router-outlet>\r\n    <router-outlet name=\"window\"></router-outlet>\r\n</div>\r\n";